import { vec3, vec4 } from "gl-matrix";

export function loadShader(
  gl: WebGL2RenderingContext,
  vertexShaderSource: string,
  fragmentShaderSource: string,
  name: string,
): WebGLProgram {
  const vertexShader = gl.createShader(gl.VERTEX_SHADER);
  const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);

  if (!vertexShader || !fragmentShader) {
    throw new Error("Failed to create shaders");
  }

  gl.shaderSource(vertexShader, vertexShaderSource);

  gl.shaderSource(fragmentShader, fragmentShaderSource);

  gl.compileShader(vertexShader);
  gl.compileShader(fragmentShader);

  /*if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
    console.groupCollapsed("Vertex shader source:");
    console.log(vertexShaderSource);
    console.groupEnd();

    throw new Error(
      `Failed to compile vertex shader for ${name}: ${gl.getShaderInfoLog(
        vertexShader,
      )}`,
    );
  }

  if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
    console.groupCollapsed("Fragment shader source:");
    console.log(fragmentShaderSource);
    console.groupEnd();

    throw new Error(
      `Failed to compile fragment shader for ${name}: ${gl.getShaderInfoLog(
        fragmentShader,
      )}`,
    );
  }*/

  const program = gl.createProgram();

  if (!program) {
    throw new Error(`Failed to create program for ${name}`);
  }

  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);

  gl.linkProgram(program);

  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    const log = gl.getProgramInfoLog(program);

    const vertexShaderLog = gl.getShaderInfoLog(vertexShader);
    const fragmentShaderLog = gl.getShaderInfoLog(fragmentShader);

    console.warn({
      log,
      vertexShaderLog,
      fragmentShaderLog,
    });

    throw new Error(
      `Failed to link program for ${name}: ${gl.getProgramInfoLog(program)}`,
    );
  }

  return program;
}

export function generateQuadBuffer(gl: WebGL2RenderingContext): WebGLBuffer {
  const positionBuffer = gl.createBuffer();

  if (!positionBuffer) {
    throw new Error("Failed to create buffer");
  }

  gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);

  const positions = [-1, -1, -1, 1, 1, -1, 1, 1];

  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);

  return positionBuffer;
}

export function setUniformVec3(
  gl: WebGL2RenderingContext,
  location: WebGLUniformLocation,
  value: vec3,
) {
  gl.uniform3f(location, value[0], value[1], value[2]);
}

export function setUniformVec4(
  gl: WebGL2RenderingContext,
  location: WebGLUniformLocation,
  value: vec4,
) {
  gl.uniform4f(location, value[0], value[1], value[2], value[3]);
}

export function getUniformLocations<T extends string>(
  gl: WebGL2RenderingContext,
  program: WebGLProgram,
  uniforms: T[],
  allowMissing = false,
): Record<`${T}Location`, WebGLUniformLocation | null> {
  const result: Partial<Record<`${T}Location`, WebGLUniformLocation | null>> =
    {};

  for (const uniform of uniforms) {
    const location = gl.getUniformLocation(program, uniform);

    if (!location && !allowMissing) {
      console.warn(`Uniform ${uniform} not found in program ${program}`);
    }

    result[`${uniform}Location`] = location;
  }

  return result as Record<`${T}Location`, WebGLUniformLocation | null>;
}
